import { useMemo, useState } from 'react';

import { Button } from '@/shared/ui';
import { useAppDispatch } from '@/shared/hooks/store';
import { CustomersController } from '@/shared/endpoints/customers';
import { ITransferPrescriptions } from '@/shared/types/interfaces/transfer-prescriptions';

import OtcMedicationForm from '../otc-medication-form';
import { MedicationCard } from '../medications-list/card';
import PrescriptionMedicationForm from '../prescription-medication-form';
import { ConfirmModal } from '@/shared/components/confirm-modal';

interface IProps {
  onClose: () => void;
  medication: ITransferPrescriptions;
}

export const MedicationUpdatePopup = ({ onClose, medication }: IProps) => {
  const dispatch = useAppDispatch();
  const [deleteModalShown, setDeleteModalShown] = useState(false);

  const FormComponent = useMemo(
    () => (medication.prescribable.otc ? OtcMedicationForm : PrescriptionMedicationForm),
    [medication.prescribable.otc]
  );

  const deleteMedication = () => {
    dispatch(CustomersController.removeTransferPrescription(medication));
    onClose();
  };

  return (
    <div data-testid="medication-update-popup-container" className="flex flex-col gap-5">
      <ConfirmModal
        open={!!deleteModalShown}
        onCancel={() => setDeleteModalShown(false)}
        onConfirm={deleteMedication}
        title="Are you sure you want to remove this medication?"
        confirmText="Yes, Remove"
        cancelText="Cancel Removal"
      >
        <MedicationCard medication={medication} showActions={false} />
      </ConfirmModal>
      {
        !deleteModalShown &&
        <>
          <FormComponent transferPrescription={medication} medication={medication.prescribable} onCreateMedication={onClose} />
          <Button testId="button-medication-update-cancel" variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button testId="button-medication-update-delete" variant="text" onClick={() => setDeleteModalShown(true)}>
            Delete Medication
          </Button>
        </>
      }
    </div>
  );
};
